(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaya-info-tabs"] && !Shopify.designMode) return;
  try {
    
  class KayaInfoTabsComponent extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const signal = this.#controller.signal;
      this.addEventListener('click', this.#onTabClick, { signal });
      this.addEventListener('keydown', this.#onKeyDown, { signal });

      const section = this.closest('.shopify-section');
      if (section) {
        section.addEventListener('shopify:block:select', this.#onBlockSelect, { signal });
      }

      this.#init();
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    #init() {
      // block.settings is not accessible from the section template for theme blocks;
      // the label is passed via data-tab-label on the panel (set within the block file).
      this.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
        const label = panel.dataset.tabLabel;
        if (!label) return;
        const tab = this.querySelector(`[aria-controls="${panel.id}"]`);
        if (tab) tab.textContent = label;
      });

      const firstTab = this.querySelector('[role="tab"]');
      if (firstTab) this.#selectTab(firstTab);
    }

    #onTabClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.#selectTab(tab);
    };

    #onKeyDown = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const index = tabs.indexOf(tab);

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        const next = tabs[(index + 1) % tabs.length];
        this.#selectTab(next);
        next.focus();
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        const prev = tabs[(index - 1 + tabs.length) % tabs.length];
        this.#selectTab(prev);
        prev.focus();
      }
    };

    #onBlockSelect = (event) => {
      const blockId = event.detail.blockId;
      const panel = [...this.querySelectorAll('.kit-panel')].find((p) => {
        const attr = p.getAttribute('data-shopify-editor-block');
        if (!attr) return false;
        try { return JSON.parse(attr).id === blockId; } catch { return false; }
      });
      if (!panel) return;

      const tab = this.querySelector(`[aria-controls="${panel.id}"]`);
      if (tab) this.#selectTab(tab);
    };

    #selectTab(tab) {
      this.querySelectorAll('[role="tab"]').forEach((t) => {
        t.setAttribute('aria-selected', 'false');
        t.classList.remove('kit-tab--active');
      });

      this.querySelectorAll('[role="tabpanel"]').forEach((p) => {
        p.hidden = true;
      });

      tab.setAttribute('aria-selected', 'true');
      tab.classList.add('kit-tab--active');

      const panelId = tab.getAttribute('aria-controls');
      const panel = this.querySelector(`#${panelId}`);
      if (panel) panel.hidden = false;
    }
  }

  if (!customElements.get('kaya-info-tabs-component')) {
    customElements.define('kaya-info-tabs-component', KayaInfoTabsComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
